import { render, staticRenderFns } from "./TextaLP.vue?vue&type=template&id=00c5b0ae&scoped=true&"
import script from "./TextaLP.vue?vue&type=script&lang=js&"
export * from "./TextaLP.vue?vue&type=script&lang=js&"
import style0 from "./TextaLP.vue?vue&type=style&index=0&id=00c5b0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c5b0ae",
  null
  
)

export default component.exports